import React from 'react';
import classnames from 'classnames';
import CheckIcon from '@wix/da-ds/pkg/Icons/16x16/Check';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Flex from '@wix/da-ds/pkg/Flex';
import s from './Benefit.scss';
var Benefit = function (_a) {
    var benefit = _a.benefit, className = _a.className;
    return (React.createElement(Flex, { className: classnames(s['root'], className), alignItems: "flex-start" },
        React.createElement(CheckIcon, { className: s['icon'], size: IconSize.SMALLER, disableDefaultColors: true }),
        React.createElement("span", null, benefit)));
};
Benefit.displayName = 'Benefit';
export default Benefit;
//# sourceMappingURL=Benefit.js.map